import * as graphic from 'echarts/lib/util/graphic';

// 将十六进制颜色转为 RGB 数组
function hexToRgb(hex) {
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);
  return [r, g, b];
}

// 将 RGBA 字符串转为 RGB 数组
function rgbaToRgb(rgba) {
  rgba = rgba
    .slice(5, rgba.length - 1)
    .split(',')
    .map(Number);
  return rgba;
}

// 混合颜色
function addAlpha(color, alpha) {
  let rgb;
  if (/^#/.test(color)) {
    rgb = hexToRgb(color);
  } else if (/^rgba/.test(color)) {
    rgb = rgbaToRgb(color);
  }
  return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${alpha})`;
}
/**
 * 绘制自定义图形
 * @param sourceData 数据源
 * @returns
 */

// 动态
export function handleRenderItem(sourceData) {
  const minOpacityPolygon = 0.1;
  const maxOpacityPolygon = 0.3;
  const minOpacityCircle = 0.4;
  const maxOpacityCircle = 1;
  const sizeArray = Array.from(new Set(sourceData.map(item => item.value[2])));
  const ratio = (maxOpacityCircle - minOpacityCircle) / (sizeArray.length - 1);
  const ratioPolygon = (maxOpacityPolygon - minOpacityPolygon) / (sizeArray.length - 1);
  const renderItem = function (params, api) {
    const position = api.coord([api.value(0), api.value(1)]);
    let lastPosition, polygonFill;
    if (
      params.dataIndex > 0 &&
      sourceData[params.dataIndex - 1].value[1] === sourceData[params.dataIndex].value[1]
    ) {
      lastPosition = api.coord([
        sourceData[params.dataIndex - 1].value[0],
        sourceData[params.dataIndex - 1].value[1]
      ]);
      const directionLeft = sourceData[params.dataIndex - 1].value[0] > api.value(0) ? 1 : 0;
      const directionLRight = sourceData[params.dataIndex - 1].value[0] > api.value(0) ? 0 : 1;
      polygonFill = new graphic.LinearGradient(directionLeft, 0, directionLRight, 0, [
        {
          offset: 0,
          color: addAlpha(
            api.style().fill,
            minOpacityPolygon +
              ratioPolygon * sizeArray.indexOf(sourceData[params.dataIndex - 1].value[2])
          )
        },
        {
          offset: 1,
          color: addAlpha(
            api.style().fill,
            minOpacityPolygon + ratioPolygon * sizeArray.indexOf(api.value(2))
          )
        }
      ]);
    }
    return {
      type: 'group',
      children: [
        lastPosition && {
          type: 'polygon',
          style: {
            fill: polygonFill
          },
          shape: {
            points: [
              [lastPosition[0], lastPosition[1] - sourceData[params.dataIndex - 1].value[2]],
              [lastPosition[0], lastPosition[1] + sourceData[params.dataIndex - 1].value[2]],
              [position[0], position[1] + api.value(2)],
              [position[0], position[1] - api.value(2)],
              [lastPosition[0], lastPosition[1] - sourceData[params.dataIndex - 1].value[2]]
            ]
          }
        },
        {
          type: 'circle',
          z2: 2,
          style: {
            stroke: '#fff',
            lineWidth: 1.5,
            opacity: minOpacityCircle + ratio * sizeArray.indexOf(api.value(2)),
            ...api.style()
          },
          shape: {
            cx: position[0],
            cy: position[1],
            r: api.value(2)
          }
        }
      ]
    };
  };
  return renderItem;
}

export function handleGraphic(data) {
  const array = [];
  data.forEach((item, index) => {
    const element = {
      type: 'circle',
      right: 70 * (data.length - index),
      shape: {
        cy: 16,
        r: item.size
      },
      style: {
        fill: '#4d5999'
      },
      textContent: {
        style: {
          text: item.name,
          fill:'#87879C'
        }
      },
      textConfig: {
        position: 'right',
        offset:[4,2]
      }
    };
    array.push(element);
  });
  return array;
}
